import { useEffect } from 'react';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import { useLanguage } from '../../context/LanguageContext';

export default function CookiePolicy() {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-8">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1A2B4A] mb-6">
            {t('cookiePolicy.title')}
          </h1>
          <p className="text-gray-600 mb-12">
            {t('cookiePolicy.lastUpdated')}
          </p>

          <div className="space-y-12">
            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('cookiePolicy.whatAreTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('cookiePolicy.whatAreText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('cookiePolicy.howUseTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('cookiePolicy.howUseText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('cookiePolicy.typesTitle')}
              </h2>
              
              <div className="space-y-6">
                <div className="border-l-4 border-[#C9A961] pl-6">
                  <h3 className="text-xl font-bold text-[#1A2B4A] mb-2">
                    {t('cookiePolicy.essentialTitle')}
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    {t('cookiePolicy.essentialText')}
                  </p>
                </div>

                <div className="border-l-4 border-[#2D7A8F] pl-6">
                  <h3 className="text-xl font-bold text-[#1A2B4A] mb-2">
                    {t('cookiePolicy.analyticsTitle')}
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    {t('cookiePolicy.analyticsText')}
                  </p>
                </div>

                <div className="border-l-4 border-[#1A2B4A] pl-6">
                  <h3 className="text-xl font-bold text-[#1A2B4A] mb-2">
                    {t('cookiePolicy.functionalTitle')}
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    {t('cookiePolicy.functionalText')}
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('cookiePolicy.managingTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('cookiePolicy.managingText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('cookiePolicy.updatesTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('cookiePolicy.updatesText')}
              </p>
            </section>

            <section className="bg-gray-50 p-8 rounded-lg border border-gray-200">
              <h2 className="text-2xl font-serif font-bold text-[#1A2B4A] mb-4">
                {t('cookiePolicy.contactTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('cookiePolicy.contactText')}
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}